import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { IStartPlacingConfig } from '@simlab/simlab-facility-management/common';
import { ICustomComponent } from '@simlab/simlab-facility-management/scene-object';
import {
  fromEvent,
  mergeMap,
  Observable,
  of,
  Subject,
  switchMap,
  takeUntil,
  tap,
  timer,
} from 'rxjs';
import { TagComponent } from '../components/tag-component';

export interface IFeatureTags {
  get component(): ICustomComponent<TagComponent>;
  startPlacingComponent$: (config: IStartPlacingConfig) => Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class FeatureTagsService implements IFeatureTags {
  private readonly _rendererFactory = inject(RendererFactory2);
  private readonly _renderer: Renderer2 = this._rendererFactory.createRenderer(
    null,
    null
  );

  readonly touchObserverDestroy: Subject<void> = new Subject<void>();

  constructor() {}

  get component(): ICustomComponent<TagComponent> {
    throw new Error('Method not implemented.');
  }
  startPlacingComponent$(config: IStartPlacingConfig): Observable<boolean> {
    return of(true).pipe(tap((e) => console.log('elooo')));
  }

  private _setDisplay(ele: HTMLElement, val: 'none' | 'flex') {
    this._renderer.setStyle(ele, 'display', val);
  }

  mobileTouchObserver(
    progress: HTMLElement,
    canvas: HTMLCanvasElement | undefined
  ) {
    // const progress = this.componentRef.instance.progress.nativeElement;
    const mouseUp$ = fromEvent(canvas as HTMLCanvasElement, 'touchend').pipe(
      tap(() => this._setDisplay(progress, 'none'))
    );
    const mouseMove$ = fromEvent(canvas as HTMLCanvasElement, 'touchmove').pipe(
      tap(() => this._setDisplay(progress, 'none'))
    );
    const mouseDown$ = fromEvent(
      canvas as HTMLCanvasElement,
      'touchstart'
    ).pipe(
      switchMap((e: Event) =>
        timer(200).pipe(
          takeUntil(mouseUp$ || mouseMove$),
          mergeMap(() => of(e))
        )
      ),
      tap((e: Event) => {
        this._setDisplay(progress, 'flex');
        this._renderer.setStyle(
          progress,
          'top',
          `${(e as TouchEvent).changedTouches[0].clientY - 120}px`
        );
        this._renderer.setStyle(
          progress,
          'left',
          `${(e as TouchEvent).changedTouches[0].clientX - 50}px`
        );
      })
    );
    return mouseDown$.pipe(
      switchMap((down: Event) =>
        timer(1000).pipe(
          takeUntil(mouseUp$ || mouseMove$),
          mergeMap(() => of(down))
        )
      ),
      tap(() => this._setDisplay(progress, 'none')),
      takeUntil(this.touchObserverDestroy)
    );
  }
}
